import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiAdvisoryCities extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}